import { render, staticRenderFns } from "./index.vue?vue&type=template&id=48c648d1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=48c648d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c648d1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SimilarBox: require('/drone/src/components/SimilarBox/index.vue').default})
